import React, { useState } from 'react';
import BadgeChip from './BadgeChip';
import { Plus } from 'lucide-react';
import { trackEvent } from '../../../utils/analytics';

const BadgeStrip = ({ badges = [], isVerified = false, compact = false }) => {
  const [expanded, setExpanded] = useState(false);

  // If no badges, return null
  if (!badges || badges.length === 0) return null;

  // Filter out VERIFIED_TRAVELER if the user is natively verified via the profile header
  const filteredBadges = badges.filter(b => !(isVerified && b.code === 'VERIFIED_TRAVELER'));

  if (filteredBadges.length === 0) return null;

  const MAX_VISIBLE = 6;
  const showExpansion = filteredBadges.length > MAX_VISIBLE;
  const visibleBadges = expanded ? filteredBadges : filteredBadges.slice(0, MAX_VISIBLE);
  const hiddenCount = filteredBadges.length - MAX_VISIBLE;

  return (
    <div className={`flex flex-wrap gap-2 items-center ${compact ? '' : 'mt-2'}`}>
      {visibleBadges.map((badge) => (
        <BadgeChip key={badge.code} badge={badge} compact={compact} />
      ))}
      
      {showExpansion && !expanded && (
        <button
          onClick={() => {
            trackEvent('badge_strip_expanded', { hidden_count: hiddenCount, total_badges: filteredBadges.length });
            setExpanded(true);
          }}
          className={`
            flex items-center gap-1 rounded-full border bg-gray-50 border-gray-200 text-gray-600
            ${compact ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm'}
            font-medium hover:bg-gray-100 transition-colors shadow-sm
          `}
        >
          <Plus size={compact ? 12 : 16} />
          <span>{hiddenCount} More</span>
        </button>
      )}
    </div>
  );
};

export default BadgeStrip;
